import axios from 'axios';

const version = 'v1';
const addInvitationUrl = `${version}/Invitation/add`;
const getInvitationUrl = `${version}/Invitation`;

export const mutations = { 
	async addInvitation(invitation) {
		await axios.post(addInvitationUrl, invitation);
	},
    async getInvitation(id) {
        return await axios.get(`${getInvitationUrl}/${id}`);
    }
}